var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComingSoonFeatureVote',{attrs:{"title":_vm.$t('broker.app.navigation.quests'),"description":_vm.$t('broker.quests.questsDescription'),"image-src":_vm.imageSrc,"feature-name":"COMING_FEATURE_QUEST"}})
}
var staticRenderFns = []

export { render, staticRenderFns }